const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '평가일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {'component': 'search-disaster-types', label: '재해형태', value: 'disaster', query: {'dty': 'disaster'}, options: {}},
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['재해형태', '평가일', '작성년도']}
      },
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  평가일
    if (search.date) {
      conditions.push({key: 'body.inputB_4', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.inputB_4', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    // 검색연도
    if (search.year) {
      let dateTarget = "created_at";
      let dateBegin = `${new Date().getFullYear()}-01-01`;
      let dateEnd = `${new Date().getFullYear()}-12-31`;
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
      conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
      conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})
    }

    //  재해형태
    if (search.disaster) {
      // riskAppraisalList 으로 검색 되도록 수정해야함
      conditions.push({key: 'body.disasters', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "작성년도",
        "key": "body.stdInfo.date"
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "작업내용",
        "key": "body.inputB_3"
      },
      {
        "name": "재해형태",
        "key": "body.riskAppraisalList[%]"
      },
      {
        "name": "평가일",
        "key": "body.inputB_4"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.section"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.date? func.getContent(value).stdInfo.date.split('-')[0] : '' // 작성년도
      case 1: return func.getContent(value).stdInfo.field_name // 사업장명
      case 2: return func.getContent(value).inputB_3 // 작업내용
      case 3: return func.getContentRiskList(func.getContent(value).riskAppraisalList)// 재해형태
      case 4: return func.getContent(value).inputB_4 // 평가일
      case 5: return func.getContent(value).stdInfo.department // 소속명
      case 6: return func.getContent(value).stdInfo.section // 부서명
      case 7: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
